module.exports = __webpack_public_path__ + "img/moonarch-logo-small.2b77a222.svg";